import { useCallback, useSyncExternalStore } from 'react'

const PRINTING_ENABLED_KEY = 'printingEnabled'

const subscribe = (callback: () => void) => {
  window.addEventListener('storage', callback)
  return () => window.removeEventListener('storage', callback)
}

const getSnapshot = () => {
  const value = localStorage.getItem(PRINTING_ENABLED_KEY)
  // Default to true (printing enabled) when key not set
  return value === null ? true : value === 'true'
}

export const usePrintingEnabled = () => {
  const printingEnabled = useSyncExternalStore(subscribe, getSnapshot)

  const setPrintingEnabled = useCallback((value: boolean) => {
    localStorage.setItem(PRINTING_ENABLED_KEY, String(value))
    window.dispatchEvent(new StorageEvent('storage', { key: PRINTING_ENABLED_KEY }))
  }, [])

  return { printingEnabled, setPrintingEnabled }
}
